import { useState, TouchEvent } from 'react'

// the required distance between touchStart and touchEnd to be detected as a swipe
const MIN_SWIPE_DISTANCE = 70

export default function useOnSwipe({
  onSwipeUp,
  onSwipeDown,
}: {
  onSwipeUp?: () => void
  onSwipeDown?: () => void
}) {
  const [touchStart, setTouchStart] = useState<number | null>(null)
  const [touchEnd, setTouchEnd] = useState<number | null>(null)

  const onTouchStart = (e: TouchEvent<HTMLElement>) => {
    setTouchEnd(null) // otherwise the swipe is fired even with usual touch events
    setTouchStart(e.targetTouches[0].clientY)
  }

  const onTouchMove = (e: TouchEvent<HTMLElement>) => setTouchEnd(e.targetTouches[0].clientY)

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return

    // if touch start is a smaller number than touch end => user swiped down
    const distance = touchEnd - touchStart

    const isDownSwipe = distance > MIN_SWIPE_DISTANCE
    const isUpSwipe = distance < -MIN_SWIPE_DISTANCE

    if (isUpSwipe) {
      onSwipeUp && onSwipeUp()
    } else if (isDownSwipe) {
      onSwipeDown && onSwipeDown()
    }
  }

  return { onTouchStart, onTouchMove, onTouchEnd }
}
